export default __webpack_public_path__ + "static/media/Repituco.031e8451.jpg";